import styled from 'styled-components';

export const Content = styled.div`
  font-weight: bold;
  font-size: 13px;
  line-height: 1;
`;
